


import 'firebaseui/dist/firebaseui.css'

import {Component, Vue} from "vue-facing-decorator";
import {currentUser, getCurrentUser, getRef, signOutUser} from "@/rtdb";
import {get, onValue, push, set} from 'firebase/database';
import {DBEvents} from "@/@types";
import {User} from "firebase/auth";


@Component({
  components: {}
})
export default class EventsView extends Vue {

  events: DBEvents | null = null

  newEventName = ''
  dialogNewEvent = false
  dialogDeleteEvent = false

  deleteEventKey = ''

  isAdmin = false

  userData: User | null = null


  async exit() {
    await signOutUser()
    setTimeout(() => location.reload(), 1000)
  }

  async addNewEvent() {
    await push(getRef(`events/`), {
      name: this.newEventName
    })
    this.dialogNewEvent = false

  }

  async deleteEvent() {
    if (!this.deleteEventKey) return;

    await set(getRef(`events/` + this.deleteEventKey), null)

    this.dialogDeleteEvent = false
  }

  async mounted() {

    this.userData = await getCurrentUser()

    this.isAdmin = !!(await get(getRef(`admins/${(await getCurrentUser())?.uid ?? 0}/`))).val()

    onValue(getRef('events'), snap => {

      this.events = snap.val() ?? {}


    })


  }

}

